import React, { useState, useEffect } from "react";
import { Tooltip, IconButton, Paper, Typography, CircularProgress } from "@mui/material";
import { CheckCircle, Warning, Info } from "@mui/icons-material";
import { useToken } from "../../items/UseToken";

const RegulationDetails = ({ countryCode, numberType, endUserType }) => {
    const [loading, setLoading] = useState(false);
    const [regulations, setRegulations] = useState([]);
    const [error, setError] = useState("");
    const [openTooltip, setOpenTooltip] = useState(false);
    const { token } = useToken();

    useEffect(() => {
        if (countryCode && numberType && endUserType) {
            fetchRegulations();
        }
    }, [countryCode, numberType, endUserType]);

    const fetchRegulations = async () => {
        setLoading(true);
        setError("");
        setRegulations([]);
        try {
            const response = await fetch(
                `api/gettwilioregulations?countryCode=${countryCode}&type=${numberType}&endUserType=${endUserType}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + token,
                    },
                }
            );            if (!response.ok) {
                throw new Error("Failed to fetch regulations.");
            }
            const data = await response.json();
            setRegulations(data[0].requirements.supporting_document);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    const hasRequirements = regulations.length > 0;

    return (
        <Tooltip
            title={
                loading ? (
                    <CircularProgress size={20} />
                ) : error ? (
                    "Could not get data from Twilio"
                ) : hasRequirements ? (
                    <Paper sx={{ p: 2, maxWidth: 300 }}>
                        <Typography variant="h6" gutterBottom>
                            Additional Regulatory Requirements
                                </Typography>
                                <Typography  variant="body2">
                                    Requires supporting documents, please go to <a href="https://sophona.com/dashboard" target="_blank" rel="noopener noreferrer">Dashboard</a> to complete Regulatory Compliance
                                </Typography>
                    </Paper>
                ) : (
                    "No additional requirements. Ready to use."
                )
            }
            open={openTooltip}
            onOpen={() => setOpenTooltip(true)}
            onClose={() => setOpenTooltip(false)}
            arrow
        >
            <IconButton color={hasRequirements || error ? "warning" : "success"}>
                {hasRequirements || error ? <Warning /> : <CheckCircle />}
            </IconButton>
        </Tooltip>
    );
};

export default RegulationDetails;
